import React, { useState } from "react";

export default function MessageInput({
  isAr = false,
  onSend,
  loading = false,
}) {
  const [value, setValue] = useState("");

  const placeholder = isAr
    ? "اكتب سؤالك هنا... مثال: أين طلبي؟ أو اقترح لي كورس مناسب"
    : "Ask anything here... for example: Where is my order? or recommend a course";

  async function handleSubmit(event) {
    event.preventDefault();

    const message = value.trim();
    if (!message || loading) {
      return;
    }

    await onSend(message);
    setValue("");
  }

  function handleKeyDown(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      handleSubmit(event);
    }
  }

  return (
    <form className="ai-chatbox__composer" onSubmit={handleSubmit}>
      <label className="ai-chatbox__composer-label">
        {isAr ? "رسالتك" : "Your message"}
      </label>

      <div className="ai-chatbox__composer-box">
        <textarea
          className="ai-chatbox__composer-input"
          rows={3}
          value={value}
          onChange={(event) => setValue(event.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          disabled={loading}
        />

        <button
          type="submit"
          className="ai-chatbox__send-button"
          disabled={loading || value.trim() === ""}
        >
          {loading ? (isAr ? "جارٍ الإرسال..." : "Sending...") : (isAr ? "إرسال" : "Send")}
        </button>
      </div>

      <p className="ai-chatbox__composer-hint">
        {isAr
          ? "اضغط Enter للإرسال وShift + Enter لسطر جديد."
          : "Press Enter to send and Shift + Enter for a new line."}
      </p>
    </form>
  );
}
